var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-153 -46 652 652",
    style: {
      enableBackground: "new -153 -46 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#114954;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.3,309H468v-35.5h-61.7V138.9c0-22.4-14.6-37.3-36.9-37.3v35.2h-64.5v35.4h30.3c17,0,29.5-8.4,34.1-21.9 v123.2h-65V309z M209.6,275.6h-42.4c-20.5,0.4-37.3-16.2-37.3-36.7V207c0-20.3,16.4-36.9,37.3-36.9h42.4 c20.7-0.4,37.7,16.2,37.7,36.9v31.9C247.3,259.4,230.3,276,209.6,275.6L209.6,275.6z M91.4,222.9c0,53.5,39.3,89.6,93.4,89.6h7.4 c54.1,0,93.5-36.1,93.5-89.6c0-53.7-39.5-89.6-93.5-89.6h-7.6C130.7,133.2,91.4,169.3,91.4,222.9L91.4,222.9z M1.2,412.5h-65.2 c-17.6,0-29.8-10.7-29.8-25.2v-2.9c0-14.8,12.3-25.8,29.8-25.8H1c17.6,0,30.3,10.9,30.3,25.8v2.9c0,14.5-12.7,25.2-30.3,25.2H1.2z  M-11.1,262.9h-41.6c-20.1,0-36.7-15.2-36.7-35.2v-21.8c0.1-20.1,16.6-36.1,36.7-36h41.6c20.3,0,36.7,15.7,36.7,36v21.5 C25.6,247.7,9.2,262.9-11.1,262.9L-11.1,262.9z M69.7,384.8c0-38.7-26.7-61.3-82.2-61.3h-69.7c-8.6,0-13.9-5.3-13.9-12.2 c0-7,5.4-12.3,13.9-12.3h52.7c54.5,0,93.6-34.4,93.6-84.8V136c-15.3,0-28.5,9.6-34.2,22.7C15.7,142.6-6,133-33.8,133h-5.7 c-49.2,0-88.3,33.4-88.3,82.6c0,25.2,10.4,44.3,27.3,57.2c-18.1,5.3-31,19.7-31,38.4c0,17.6,10.7,31.3,26.8,37.3 c-17,9.6-27.3,24.4-27.3,44.7c0,34,33.4,56.1,98.8,56.1h3.9C36.4,449.4,69.7,426.4,69.7,384.8L69.7,384.8z M69.7,384.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo1);
export default __webpack_public_path__ + "static/media/go1.d07c3fe33deaa7d35d5df9e9d57f29d0.svg";
export { ForwardRef as ReactComponent };